import { Campaign } from "@vviinn/user-managment-client-ts";

import { HandleChangeKey } from "../../../../types";
import { typecastedTextSearch } from "../../../../textSearch/typecastedTextSearch";
import { textCampaignWeightsKeys } from "../../../../textSearch/constants";
import { TextSearchNumbericTitlesKey } from "../../../../textSearch/types";

export const getCampaignValue = (key: HandleChangeKey, campaign: Campaign) =>
  key in textCampaignWeightsKeys
    ? typecastedTextSearch(key as TextSearchNumbericTitlesKey, campaign).value
    : campaign[key as Exclude<HandleChangeKey, TextSearchNumbericTitlesKey>];
